/**
 * Residence Type Selector Component
 * Reusable radio button group for selecting residence type
 */

import type { ResidenceType } from '@/features/applicant/types/address'

interface ResidenceTypeSelectorProps {
  value: ResidenceType
  onChange: (value: ResidenceType) => void
  name?: string
  className?: string
  isReadOnly?: boolean
}

export function ResidenceTypeSelector({
  value,
  onChange,
  name = 'residence',
  className = '',
  isReadOnly = false,
}: ResidenceTypeSelectorProps) {
  return (
    <div className={`${className} mb-6`}>
      <p className="text-sm font-semibold text-gray-700 mb-3">Type of residence*</p>
      <div className="flex gap-6">
        <label className="flex items-center cursor-pointer group">
          <input 
            type="radio" 
            name={name}
            checked={value === 'rent'}
            onChange={() => !isReadOnly && onChange('rent')}
            disabled={isReadOnly}
            className="mr-2 w-4 h-4 text-blue-600 focus:ring-blue-500 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50" 
          />
          <span className="text-sm text-gray-700 group-hover:text-gray-900">Rent</span>
        </label>
        <label className="flex items-center cursor-pointer group">
          <input 
            type="radio" 
            name={name}
            checked={value === 'own'}
            onChange={() => !isReadOnly && onChange('own')}
            disabled={isReadOnly}
            className="mr-2 w-4 h-4 text-blue-600 focus:ring-blue-500 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50" 
          />
          <span className="text-sm text-gray-700 group-hover:text-gray-900">Own</span>
        </label>
        <label className="flex items-center cursor-pointer group">
          <input 
            type="radio" 
            name={name}
            checked={value === 'family'}
            onChange={() => !isReadOnly && onChange('family')}
            disabled={isReadOnly}
            className="mr-2 w-4 h-4 text-blue-600 focus:ring-blue-500 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50" 
          />
          <span className="text-sm text-gray-700 group-hover:text-gray-900">Family Or Other</span>
        </label>
      </div>
    </div>
  )
}

